import { Link } from "react-router-dom";

import type { Product } from "@/api/shop";
import { Price } from "./Price";

const KIND_LABEL: Record<string, string> = {
  robot: "Robot / EA",
  signal: "Signals",
  course: "Course",
  indicator: "Indicator",
  data_feed: "Data feed",
};

const KIND_ICON: Record<string, string> = {
  robot: "🤖",
  signal: "📈",
  course: "🎓",
  indicator: "📊",
  data_feed: "🛰️",
};

export function ProductCard({ product }: { product: Product }) {
  const from = product.skus.length
    ? product.skus.reduce((min, s) => (s.price_cents < min.price_cents ? s : min), product.skus[0])
    : null;

  return (
    <Link
      to={`/p/${product.slug}`}
      className="group flex flex-col rounded-xl border border-line bg-surface p-5 shadow-card transition-all duration-200 hover:-translate-y-0.5 hover:border-line-strong hover:shadow-card-hover"
    >
      <div className="flex items-center justify-between">
        <span className="grid h-10 w-10 place-items-center rounded-lg bg-surface-alt text-lg">
          {KIND_ICON[product.kind] ?? "✨"}
        </span>
        <span className="rounded-full bg-brand-soft px-2.5 py-1 text-[0.68rem] font-semibold uppercase tracking-wide text-brand-strong">
          {KIND_LABEL[product.kind] ?? product.kind}
        </span>
      </div>

      <h3 className="mt-4 text-base font-bold text-ink">{product.name}</h3>
      {product.summary && (
        <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-ink-soft">{product.summary}</p>
      )}

      <div className="mt-5 flex items-center justify-between border-t border-line pt-4">
        {from ? (
          <span className="text-sm text-ink-mute">
            from{" "}
            <span className="text-base font-bold text-ink">
              <Price cents={from.price_cents} currency={from.currency} />
            </span>
          </span>
        ) : (
          <span className="text-sm text-ink-mute">Unavailable</span>
        )}
        <span className="text-sm font-semibold text-brand-strong transition-transform group-hover:translate-x-0.5">
          View →
        </span>
      </div>
    </Link>
  );
}
